import { render } from "./D_commonReceiveCard .vue?vue&type=template&id=437af318"
import script from "./D_commonReceiveCard .vue?vue&type=script&lang=js"
export * from "./D_commonReceiveCard .vue?vue&type=script&lang=js"

import "./D_commonReceiveCard .vue?vue&type=style&index=0&id=437af318&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__